import { render, staticRenderFns } from "./CorrespondenceSalutationSelect.vue?vue&type=template&id=bde3dde4"
import script from "./CorrespondenceSalutationSelect.vue?vue&type=script&lang=js"
export * from "./CorrespondenceSalutationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports